export default __webpack_public_path__ + "static/media/img_val_2.96c4c1da.JPG";